import { createNode, DurationDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromDuration } from '../../utils/temporal';

export const DurationNode = createNode({
    id: 'Duration',
    name: 'Duration',
    description: 'Creates a Duration value from time components',
    aiDescription:
        'Takes optional number inputs on "Years", "Months", "Weeks", "Days", "Hours", "Minutes", "Seconds", and "Milliseconds" ports and outputs a Duration on the "Duration" port. All inputs default to 0.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Years: { kind: 'number' },
        Months: { kind: 'number' },
        Weeks: { kind: 'number' },
        Days: { kind: 'number' },
        Hours: { kind: 'number' },
        Minutes: { kind: 'number' },
        Seconds: { kind: 'number' },
        Milliseconds: { kind: 'number' },
    },
    optionalInPorts: ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Minutes', 'Seconds', 'Milliseconds'],
    outPorts: {
        Duration: DurationDataType,
    },
    execute: function (input) {
        const duration = Temporal.Duration.from({
            years: input.inPorts.Years ?? 0,
            months: input.inPorts.Months ?? 0,
            weeks: input.inPorts.Weeks ?? 0,
            days: input.inPorts.Days ?? 0,
            hours: input.inPorts.Hours ?? 0,
            minutes: input.inPorts.Minutes ?? 0,
            seconds: input.inPorts.Seconds ?? 0,
            milliseconds: input.inPorts.Milliseconds ?? 0,
        });
        return { output: { Duration: fromDuration(duration) } };
    },
});
